var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99844 19.5984C12.5445 19.5984 14.9863 18.587 16.7867 16.7867C18.587 14.9863 19.5984 12.5445 19.5984 9.99844C19.5984 7.45236 18.587 5.01056 16.7867 3.21021C14.9863 1.40986 12.5445 0.398438 9.99844 0.398438C7.45236 0.398438 5.01056 1.40986 3.21021 3.21021C1.40986 5.01056 0.398438 7.45236 0.398438 9.99844C0.398438 12.5445 1.40986 14.9863 3.21021 16.7867C5.01056 18.587 7.45236 19.5984 9.99844 19.5984ZM14.4468 8.44684C14.6654 8.22051 14.7864 7.91739 14.7836 7.60276C14.7809 7.28812 14.6547 6.98714 14.4322 6.76465C14.2097 6.54216 13.9088 6.41596 13.5941 6.41323C13.2795 6.41049 12.9764 6.53145 12.75 6.75004L8.79844 10.7016L7.24684 9.15004C7.02051 8.93145 6.71739 8.81049 6.40275 8.81323C6.08812 8.81596 5.78714 8.94216 5.56465 9.16465C5.34216 9.38714 5.21596 9.68812 5.21323 10.0028C5.21049 10.3174 5.33145 10.6205 5.55004 10.8468L7.95004 13.2468C8.17507 13.4718 8.48024 13.5982 8.79844 13.5982C9.11663 13.5982 9.4218 13.4718 9.64684 13.2468L14.4468 8.44684Z",
    fill: "#19C3C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickIcon);
export default __webpack_public_path__ + "static/media/green-tick-icon.171c53985929fe335a7ce48deda32b2a.svg";
export { ForwardRef as ReactComponent };